import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiUrls, Doctypes } from 'src/app/shared/api-urls';

@Component({
  selector: 'app-lhnd-settings',
  templateUrl: './lhnd-settings.component.html',
  styleUrls: ['./lhnd-settings.component.scss']
})
export class LhndSettingsComponent implements OnInit {
lhndData;
  p = 1;
  constructor(private router: Router, private http : HttpClient) { }

  ngOnInit(): void {
    this.http.get(ApiUrls.lhdl_settings).subscribe((res:any) => {
      if(res){
        console.log(res);
        this.lhndData = res.data
      }
    })
  }

  /**
   * Navigates gsp apis component
   * @params data
   * @params type
   */
  navigate(data: any, type: string): void {
    console.log(data.name);
    this.router.navigate(['/home/lhnd-details'], { queryParams: { id: data.name } });
  }

}
